import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=168fbc2b"
import script from "./CertificateList.vue?vue&type=script&lang=ts"
export * from "./CertificateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports